export const translate = (x, y) => `translate(${x},${y})`;
export const px = val => `${val}px`;
export const clamp = (a, b, c) =>  Math.min(c, Math.max(a, b));

export default {
  translate,
  px,
  clamp
};
